import Script from 'next/script';

export default function TikTokScript() {
  return (
    <Script
      src="https://analytics.tiktok.com/i18n/pixel/events.js"
      strategy="afterInteractive"
      id="tiktok"
    />
  );
}
